<template>
  <div class="massive-reserve-transfers-list-one-server--container">
    <el-table
      :data="transfers"
      :show-header="false"
    >
      <el-table-column prop="arrow">
        <div class="arrow-icon">
          <fa :icon="['fas', 'level-up-alt']" />
        </div>
      </el-table-column>
      <el-table-column
        prop="server_to-name"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="serverId == null || scope.row.server_to.id !== serverId"
            content="Перейти в страницу сервера"
            :open-delay="1000"
          >
            <el-link
              type="primary"
              @click="goToServerPage(scope.row.server_to.id, scope.row.server_to.id_operator)"
              class="link"
            >
              {{ scope.row.server_to.name || 'Нет данных' }}
            </el-link>
          </el-tooltip>
          <template v-else>
            {{ scope.row.server_to.name || 'Нет данных' }}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="status_description">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.is_report_accessible === 1"
            content="Перейти в ЛК администратора"
            :open-delay="1000"
          >
            <el-link
              type="primary"
              class="link"
              @click="goToReportInAdminLk(scope.row.id_reserve_transfer)"
            >
              {{ scope.row.status_description }}
            </el-link>
          </el-tooltip>
          <template v-else>
            {{ scope.row.status_description }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="Дата/время" prop="start_dt" />
      <el-table-column>
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status !== 11"
            class="return_button"
            size="small"
            type="primary"
            :loading="isReturnButtonLoading"
            @click="() => handleReturnCamerasButton(scope.row)"
          >
            Вернуть камеры на свой сервер
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLevelUpAlt } from "@fortawesome/free-solid-svg-icons";

library.add(faLevelUpAlt);

export default {
  name: 'MassiveReserveFromOneServerList',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    serverId: {
      type: Number,
      default: null
    },
    goToServerPage: {
      type: Function,
      default: () => {},
    },
    goToReportInAdminLk: {
      type: Function,
      default: () => {},
    },
    isReturnButtonLoading: {
      type: Boolean,
      default: false,
    },
    handleReturnCamerasButton: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      transfers: []
    }
  },
  created () {
    this.transfers = [...this.data]
    this.transfers.shift()
  }
}
</script>

<style>
.massive-reserve-transfers-list-one-server--container {
  margin-left: 48px;
}
.arrow-icon {
  width: 100%;
  color: #666666;
  transform: rotate(90deg);
  text-align: center;
  opacity: 0.4;
}
</style>
